import { FC } from "react";

import { IRideDto } from "@ryde/shared";

import { MlPathIndicatorCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const MlPathIndicatorCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
}) => {
  return <MlPathIndicatorCell {...(rowOriginal as Partial<IRideDto>)} />;
};
